import React, { useState, useEffect } from 'react';
import API from '../../pages/Api';
import { toast } from 'react-toastify';
import PaymentPage from './PaymentPage';

const UpcomingEvents = () => {
    
    const [eventData, setEventData] = useState([]);
    const [bookedEvents, setBookedEvents] = useState([]);
    const [loading, setLoading] = useState(true);
    const [showPayment, setShowPayment] = useState(false);
    const [selectedEvent, setSelectedEvent] = useState(null);
    // const isMobile = useMediaQuery({
    //     maxWidth: 767,
    // })

    
    const fetchEvents = async () => {
        try {
            const response = await API.get(`upcoming-events/`);
            setEventData(response.data);
        } catch (error) {
            console.error("Error fetching events:", error);
        }
    };

    const checkBookings = async () => {
        try {

            const token = localStorage.getItem('access_token');

            if (!token) return;

            const res = await API.get(
                `user/user-event-bookings/`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                }
            );

            console.log("Booked Events =", res.data);

            setBookedEvents(res.data);

        } catch (err) {

            console.error(
                "Error fetching booked events:",
                err.response?.data || err
            );

        }
    };

    const isEventExpired = (event) => {
        const today = new Date();

        const endDate = new Date(event.todate);

        endDate.setHours(23, 59, 59, 999);

        return endDate < today;
    };

    
    useEffect(() => {
        const init = async () => {
            setLoading(true);
            await fetchEvents();
            await checkBookings();
            setLoading(false);
        };
        init();
    }, []);
    if (showPayment && selectedEvent) {
        return (
            <PaymentPage
                selectedCourses={[]}
                eventDetails={{
                    id: selectedEvent.eventid,
                    name: selectedEvent.eventname,
                    venue: selectedEvent.venue,
                    f: selectedEvent.fees,
                    d: '1 Day',
                    frmTime: selectedEvent.frmtime,
                    ToTime: selectedEvent.totime,
                    amountDollar: 0
                }}
                onBack={() => setShowPayment(false)}
                userInfo={JSON.parse(localStorage.getItem('user') || '{}')}
            />
        );
    }

    const formatDate = (dateStr) => {
        if (!dateStr) return "N/A";
        const d = new Date(dateStr);
        return isNaN(d.getTime()) ? dateStr : d.toLocaleDateString('en-GB');
    };

    if (loading) return <div className="p-10 text-center font-bold text-blue-600">Loading Events...</div>;

    return (
        <div className="p-3 md:p-4 animate-in fade-in duration-500">
            <div className="w-full py-3.5 text-center rounded-lg">
                    <h2 className="text-center text-xl md:text-4xl font-light text-gray-700 tracking-tight break-words">Upcoming Events</h2>
                    
            </div>
            <div className="bg-white rounded-lg shadow-md border border-gray-200">
                <div className="md:hidden space-y-4">

                    {eventData.length > 0 ? (
                        eventData.map((event) => {

                        const isBooked = bookedEvents.includes(event.eventid);
                        const isExpired = isEventExpired(event);

                        return (
                            <div
                            key={event.eventid}
                            className={`rounded-xl
                            border
                            shadow-sm
                            p-4
                            bg-white
                            w-full
                            space-y-3 ${
                                isExpired
                                ? "bg-gray-100 border-gray-300"
                                : "bg-white border-gray-200"
                            }`}
                            >

                            <h3 className="font-bold text-blue-950 text-lg mb-3">
                                {event.eventname}
                            </h3>

                            <div className="space-y-2 text-sm">

                                <div>
                                <span className="font-semibold">Date:</span>
                                <br />
                                {formatDate(event.fromdate)} - {formatDate(event.todate)}
                                </div>

                                <div>
                                <span className="font-semibold">Time:</span>
                                <br />
                                {event.frmtime} to {event.totime}
                                </div>

                                <div>
                                <span className="font-semibold">Venue:</span>
                                <br />
                                {event.venue}
                                </div>

                            </div>

                            <button
                                disabled={isBooked || isExpired}
                                onClick={() => {
                                setSelectedEvent(event);
                                setShowPayment(true);
                                }}
                                className={`mt-3 w-full h-11 py-2 rounded-lg text-white font-semibold ${
                                isExpired
                                    ? "bg-gray-500"
                                    : isBooked
                                    ? "bg-green-600"
                                    : "bg-blue-600 hover:bg-blue-700"
                                }`}
                            >
                                {isExpired
                                ? "Expired"
                                : isBooked
                                ? "Booked"
                                : "Book Now"}
                            </button>

                            </div>
                        );
                        })
                    ) : (
                        <div className="text-center text-gray-400 py-10">
                        No events available.
                        </div>
                    )}

                    </div>
                <table className="hidden md:table w-full text-sm text-center border-collapse">
                    <thead>
                        <tr className="bg-blue-950 text-white font-bold border-b">
                            <th className="p-4 border-r w-[25%]">Event Name</th>
                            <th className="p-4 border-r w-[15%]">Date</th>
                            <th className="p-4 border-r w-[20%]">Time</th>
                            <th className="p-4 border-r w-[25%]">Venue</th>
                            <th className="p-4 w-[15%]">Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {eventData.length > 0 ? (
                            eventData.map((event) => {
                                const isBooked = bookedEvents.includes(event.eventid);

                                const isExpired = isEventExpired(event);
                                return (
                                    <tr
                                        key={event.eventid}
                                        className={`border-b transition-colors ${
                                            isExpired
                                                ? "bg-gray-100 text-gray-500"
                                                : "hover:bg-gray-50"
                                        }`}
                                    >
                                        <td className="p-4 border-r font-semibold text-gray-700">{event.eventname}</td>
                                        <td className="p-4 border-r text-gray-600">
                                            <div className="flex flex-col items-center">
                                                <span>{formatDate(event.fromdate)}</span>
                                                <span className="text-gray-400 text-[10px]">to</span>
                                                <span>{formatDate(event.todate)}</span>
                                            </div>
                                        </td>
                                        <td className="p-4 border-r text-gray-600 text-[12px] font-semibold">
                                            {event.frmtime} to {event.totime}
                                        </td>
                                        <td className="p-4 border-r text-gray-600">{event.venue}</td>
                                        <td className="p-4">
                                            <button
                                                disabled={isBooked || isExpired}
                                                onClick={() => {
                                                    setSelectedEvent(event);
                                                    setShowPayment(true);
                                                }}
                                                className={`${
                                                    isExpired
                                                        ? "bg-gray-500 cursor-not-allowed"
                                                        : isBooked
                                                        ? "bg-green-600 cursor-default"
                                                        : "bg-blue-600 hover:bg-blue-700"
                                                } text-white px-5 py-1.5 rounded-md text-xs font-bold transition-all`}
                                            >
                                                
                                                {
                                                    isExpired
                                                        ? "Expired"
                                                        : isBooked
                                                        ? "Booked"
                                                        : "Book Now"
                                                }
                                            </button>


                                        </td>
                                    </tr>
                                );
                            })
                        ) : (
                            <tr>
                                <td colSpan="5" className="p-10 text-gray-400 italic">No events available.</td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default UpcomingEvents;